export const HEADER_COLUMNS = [
  'Request Number',
  'From Site',
  'To Site',
  'Type',
  'Status',
  'Creation Date',
  'Tracking Number',
  'Tracking Status',
  'Expected Delivery Date',
  'Delivered Date',
  'Region'
] as const;

export const LINE_COLUMNS = [
  'Description',
  'Serial Number',
  'Asset Number',
  'Item Number',
  'Validated Serial Number',
  'Validated Asset Number',
  'Validated Serial Item',
  'To Subinventory',
  'To Locator',
  'Is Serial Valid',
  'Validated Serial Site',
  'Status'
] as const;